import { memo } from 'react';

import { LangChooserInfoNameStyled, LangChooserInfoWrapperStyled } from './styled/LangInfoStyled.js';
import { Icon } from '../../../../components/icon/Icon';

export const LangInfo = memo(({ iconName, langName, isHideName }) => (
    <LangChooserInfoWrapperStyled>
        <Icon name={`flag-${iconName}`} height="24px" width="24px"/>
        {!isHideName && <LangChooserInfoNameStyled>{langName}</LangChooserInfoNameStyled>}
    </LangChooserInfoWrapperStyled>
))